module.exports = __webpack_public_path__ + "static/media/empty-org.5d3babbe.svg";